'use strict'
module.exports = {
  // Replace the image at this path with a 512x512 png
  favicon: "../src/assets/favicon.png",

  page: {
    title: "Lucre Games 🤞 An Indie Game Studio",
    description: "Creating game experiences that balance fun with intrigue and mechanics with art.",
    keywords: "Lucre, Games, Lucre Games, Indie Game Studio, Game Developers, Mobile Game Developers, Indie Game Developers",
    url: "https://lucregames.com",
  },

  social: {
    image: "https://lucregames.com/static/lucre-games-indie-game-sacramento-social-card.jpg",
    links: [
      { icon: 'twitter', url: 'https://twitter.com/LucreGames/' },
      { icon: 'facebook', url: 'https://www.facebook.com/LucreGames/' },
    ]
  },

  gtmContainer: 'GTM-PDC47N5',

}



//////////////////
// WEBPACK FOOTER
// ./config/site.js
// module id = PaZl
// module chunks = 0